export type ShopTab = 'orders' | 'promos' | 'gift-cards' | 'delivery' | 'settings';

/** Вкладка раздела из адреса; «Заказы» — по умолчанию, в адресе не пишется. */
export function isShopTab(value: unknown): value is Exclude<ShopTab, 'orders'> {
  return (
    value === 'promos' || value === 'gift-cards' || value === 'delivery' || value === 'settings'
  );
}
